import React, { useState, useEffect, useCallback } from "react";
import { Modal, OverlayTrigger, Tooltip, Form } from "react-bootstrap";
import "./EditFieldModal.css";
import { SubHeading } from "../../../../Global/GlobalText";
import { InputLabel, InputType, SelectBorder } from "../../../../Global/GlobalFormElement";
import { GreyBorderButton, RedBackgroundButton } from "../../../../Global/GlobalButton";
import { RiDeleteBin4Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { setFieldPayload } from "../../../../Redux/Users/fieldAction";
import { addFieldPayload, resetState, updateFieldPayload } from "../../../../Redux/Users/action";


const EditFieldModal = ({ fieldType, field, onSave, onClose, dataNames, formSchema }) => {
  const [selectedFieldLabel, setSelectedFieldLabel] = useState(field.label);
  const [selectedDataName, setSelectedDataName] = useState(field.dataName);
  const [newSelectedFieldLabel, setNewSelectedFieldLabel] = useState("");
  const [newSelectedDataName, setNewSelectedDataName] = useState("");

  const fieldPayload = useSelector((state) => state.field.fieldPayload);

  const [updatedField, setUpdatedField] = useState({
    ...field,
    options: field.options || [],
    includeOther: field.includeOther || false,
    dataName: field.dataName || `field_${Date.now()}`,
    updaTEDATANEM: dataNames
  });
  const dispatch = useDispatch();

  const fileTypes = [
    ".jpg",
    ".zip",
    ".png",
    ".jpeg",
    ".tif",
    ".wmf",
    ".eps",
    ".bmp",
    ".tiff",
    ".gif",
    ".pdf",
    ".doc",
    ".rtf",
    ".pptx",
    ".xls",
    ".ppt",
    ".docx",
    ".xlsx",
    ".txt"
  ];


  console.log(formSchema, "fomrsdaddasdasdadsadas")
  const [conditions, setConditions] = useState({
    isRequiredChecked: field.isRequired ?? true,
    isRequiredIf: field.isRequiredIf || false,
    requiredFieldValue: field.requiredFieldValue ? field.requiredFieldValue : "",
    requiredCondition: field.requiredCondition ? field.requiredCondition : "Equals (Default)",
    requiredConditionValue: field.requiredConditionValue ? field.requiredConditionValue : "",
    isVisibleChecked: field.visible ?? true,
    isVisibleIfChecked: field.isVisibleIf || false,
    visibleFieldValue: field.visibleFieldValue || "",
    visibleCondition: field.visibleCondition || "Equals (Default)",
    visibleConditionValue: field.visibleConditionValue || "",
    toselectedDataName: field.dataName,
    toselectedlabel: field.label,
    selectedLabelPosition: field.selectedLabelPosition ? field.selectedLabelPosition : "top",
    selectedFieldSize: field.selectedFieldSize ? field.selectedFieldSize : "100%",
    uploadFileSize: field.uploadFileSize ? field.uploadFileSize : "",
    uploadFileType: field.uploadFileType || [], 
  });


  const [errors, setErrors] = useState({});

  const isAddedField = fieldType === 'added';

  useEffect(() => {
    const fieldToEdit = fieldPayload.find(item => item.dataName === field.dataName);

    if (fieldToEdit) {
      setUpdatedField({
        ...fieldToEdit,
        options: fieldToEdit.options || [],
        includeOther: fieldToEdit.includeOther || false,
      });

      setConditions({
        isRequiredChecked: fieldToEdit.required ?? true,
        isRequiredIf: fieldToEdit.isRequiredIf || false,
        requiredFieldValue: fieldToEdit.requiredFieldValue ? fieldToEdit.requiredFieldValue : "",
        requiredCondition: fieldToEdit.requiredCondition ? fieldToEdit.requiredCondition : "Equals (Default)",
        requiredConditionValue: fieldToEdit.requiredConditionValue ? fieldToEdit.requiredConditionValue : "",
        isVisibleChecked: fieldToEdit.visible ?? true,
        isVisibleIfChecked: fieldToEdit.isVisibleIf || false,
        visibleFieldValue: fieldToEdit.visibleFieldValue || "",
        visibleCondition: fieldToEdit.visibleCondition || "Equals (Default)",
        visibleConditionValue: fieldToEdit.visibleConditionValue || "",
        selectedLabelPosition: fieldToEdit.selectedLabelPosition ? fieldToEdit.selectedLabelPosition : "top",
        selectedFieldSize: fieldToEdit.selectedFieldSize ? fieldToEdit.selectedFieldSize : "100%",
        uploadFileSize: fieldToEdit.uploadFileSize ? fieldToEdit.uploadFileSize : "",
        uploadFileType: fieldToEdit.uploadFileType || [],

      });

      setSelectedFieldLabel(fieldToEdit.label);
      setSelectedDataName(fieldToEdit.dataName);
    } else {
      setConditions({
        isRequiredChecked: field.isRequired ?? true,
        isRequiredIf: field.isRequiredIf || false,
        requiredFieldValue: field.requiredFieldValue ? field.requiredFieldValue : "",
        requiredCondition: field.requiredCondition ? field.requiredCondition : "Equals (Default)",
        requiredConditionValue: field.requiredConditionValue ? field.requiredConditionValue : "",
        isVisibleChecked: field.visible ?? true,
        isVisibleIfChecked: field.isVisibleIf || false,
        visibleFieldValue: field.visibleFieldValue || "",
        visibleCondition: field.visibleCondition || "Equals (Default)",
        visibleConditionValue: field.visibleConditionValue || "",
        selectedLabelPosition: field.selectedLabelPosition ? field.selectedLabelPosition : "top",
        selectedFieldSize: field.selectedFieldSize ? field.selectedFieldSize : "100%",
        uploadFileSize: field.uploadFileSize ? field.uploadFileSize : "",
        uploadFileType: field.uploadFileType || [],

      });
    }
  }, [field, fieldPayload]);



  const handleChange = useCallback((e) => {
    const { name, value, type, checked } = e.target;

    if (name === "labelPosition") {
      setConditions((prev) => ({
        ...prev,
        selectedLabelPosition: value,
      }));
    } else if (name === "fieldSize") {
      setConditions((prev) => ({
        ...prev,
        selectedFieldSize: value,
      }));
    } else if (name === "uploadFileSize") {
      setConditions((prev) => ({
        ...prev,
        uploadFileSize: value,
      }));
    } else {
      setUpdatedField((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  }, []);

  const handleFieldLabelChange = (e) => {
    const selectedLabel = e.target.value;


    const selectedItem = formSchema.find((item) => item.label === selectedLabel);

    if (selectedItem) {
      setNewSelectedFieldLabel(selectedLabel);
      setNewSelectedDataName(selectedItem.dataName);
    } else {
      setNewSelectedFieldLabel("");
      setNewSelectedDataName("");
    }
  };

  const handleConditionChange = useCallback((e) => {
    const { name, value, type, checked } = e.target;

    setConditions((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

  }, []);


  const addValue = useCallback(() => {
    setUpdatedField((prev) => ({
      ...prev,
      options: [...prev.options, ""],
    }));
  }, []);


  const updateOption = (index, value) => {
    const options = [...updatedField.options];
    options[index] = value;
    setUpdatedField({ ...updatedField, options });
  };


  const removeOption = (index) => {
    const options = [...updatedField.options];
    options.splice(index, 1);
    setUpdatedField({ ...updatedField, options });
  };


  const handleMultiSelect = (e) => {
    const selectedValue = e.target.value;

    setConditions((prev) => {
      // If the selected value is already in the array, don't add it again
      if (prev.uploadFileType.includes(selectedValue)) {
        return prev;
      }

      return {
        ...prev,
        uploadFileType: [...prev.uploadFileType, selectedValue],
      };
    });
  };

  const removeOptionDrop = (option) => {
    setConditions((prev) => ({
      ...prev,
      uploadFileType: prev.uploadFileType.filter((item) => item !== option),
    }));
  }

  const validateForm = useCallback(() => {
    const newErrors = {};

    if (!updatedField.dataName) newErrors.dataName = "Data name is required.";
    if (!updatedField.label) newErrors.label = "Label is required.";

    if (conditions.isRequiredChecked) {
      if (conditions.isRequiredIf && !conditions.requiredFieldValue) {
        newErrors.requiredFieldValue = "Required field value is required.";
      }
    }
    if (conditions.isVisibleChecked) {
      if (conditions.isVisibleIfChecked && !conditions.visibleFieldValue) {
        newErrors.visibleFieldValue = "Visible field value is required.";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [updatedField, conditions]);

  useEffect(() => {
    console.log("Updated conditions:", conditions);
  }, [conditions]);

  const handleSave = useCallback(() => {
    console.log("Attempting to save...");
    console.log("Required Field Value:", conditions.requiredFieldValue);

    if (!validateForm()) {
      console.log("Validation failed.");
      return;
    }

    if (!updatedField || !conditions) {
      console.error("Updated field or conditions are not defined.");
      return;
    }

    let updatedConditions = { ...conditions };

    if (!conditions.isRequiredIf) {
      updatedConditions = {
        ...updatedConditions,
        requiredFieldValue: "",
        requiredCondition: "Equals (Default)",
        requiredConditionValue: "",
      };
    }

    if (!conditions.isVisibleIfChecked) {
      updatedConditions = {
        ...updatedConditions,
        visibleFieldValue: "",
        visibleCondition: "Equals (Default)",
        visibleConditionValue: "",
      };
    }


    const fieldPayload = {
      type: updatedField.type,
      dataName: updatedField.dataName,
      label: updatedField.label,
      hoverHint: updatedField.hoverHint || "",
      options: updatedField.options,
      required: updatedConditions.isRequiredChecked,
      includeOther: updatedField.includeOther,
      isRequiredIf: updatedConditions.isRequiredIf,
      requiredFieldValue: updatedConditions.requiredFieldValue,
      requiredCondition: updatedConditions.requiredCondition,
      requiredConditionValue: updatedConditions.requiredConditionValue,
      visible: updatedConditions.isVisibleChecked,
      isVisibleIf: updatedConditions.isVisibleIfChecked,
      visibleFieldValue: updatedConditions.visibleFieldValue,
      visibleCondition: updatedConditions.visibleCondition,
      visibleConditionValue: updatedConditions.visibleConditionValue,
      renderlabel: selectedFieldLabel,
      renderDataName: selectedDataName,
      selectedLabelPosition: updatedConditions.selectedLabelPosition,
      selectedFieldSize: updatedConditions.selectedFieldSize,
      uploadFileSize: updatedConditions.uploadFileSize || "",
      uploadFileType: updatedConditions.uploadFileType || [],

    };

    console.log("Field Payload before save:", fieldPayload);

    try {
      dispatch(setFieldPayload(fieldPayload));
      // dispatch(resetState());
      onSave(fieldPayload);
      onSave(updatedField);
      onClose();
    } catch (error) {
      console.error("Error during save operation:", error);
    }
  }, [
    validateForm,
    updatedField,
    conditions,
    newSelectedFieldLabel,
    selectedDataName,
    selectedFieldLabel,
    onSave,
    onClose,
    dispatch
  ]);


  useEffect(() => {
    const fieldToEdit = fieldPayload.find(item => item.dataName === field.dataName);
    if (fieldToEdit) {
      setUpdatedField({
        ...fieldToEdit,
      });
    }
  }, [fieldPayload, field.dataName]);

  console.log(conditions.uploadFileType, "asdasasd")

  return (
    <Modal show={true} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Field Editor</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="registration_edit">
          <div className="registration_edit_heading">
            <SubHeading>
              Form Fields Editor:{" "}
              {updatedField.type.charAt(0).toUpperCase() + updatedField.type.slice(1)}
            </SubHeading>
          </div>
          <form className="registration_edit_form">
            <div className="registration_edit_row">
              <InputLabel>Field Type</InputLabel>
              <InputType type="text" value={updatedField.type || ""} disabled />
            </div>
            <div className="registration_edit_row">
              <InputLabel>Data Name</InputLabel>
              <InputType
                type="text"
                name="dataName"
                value={updatedField.dataName || ""}
                onChange={handleChange}
                disabled
              />
              {errors.dataName && <div className="error">{errors.dataName}</div>}
            </div>
            <div className="registration_edit_row">
              <InputLabel>Label</InputLabel>
              <InputType
                type="text"
                name="label"
                value={updatedField.label || (fieldPayload && fieldPayload.find(item => item.dataName === field.dataName)?.label || '')}

                onChange={handleChange}
              />
              {errors.label && <div className="error">{errors.label}</div>}
            </div>
            <div className="registration_edit_row">
              <InputLabel>Hover Hint</InputLabel>
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip">{updatedField.hoverHint}</Tooltip>}
              >
                <InputType
                  type="text"
                  name="hoverHint"
                  value={updatedField.hoverHint || ""}
                  onChange={handleChange}
                  placeholder="Enter a hint for the side"
                />
              </OverlayTrigger>
            </div>

            <div className="registration_edit_row">
              <InputLabel>Label Position</InputLabel>
              <div className="registration_edit_ckeck">
                <Form.Check
                  type="radio"
                  label="Top"
                  name="labelPosition"
                  value="top"
                  checked={conditions.selectedLabelPosition === "top"}
                  onChange={handleChange}
                />
                <Form.Check
                  type="radio"
                  label="Left"
                  name="labelPosition"
                  value="left"
                  checked={conditions.selectedLabelPosition === "left"}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="registration_edit_row">
              <InputLabel>Field Size</InputLabel>
              <SelectBorder
                as="select"
                name="fieldSize"
                value={conditions.selectedFieldSize || "100%"}
                onChange={handleChange}
              >
                <option value="50%">50%</option>
                <option value="75%">75%</option>
                <option value="100%">100%</option>
                <option value="auto">Auto</option>
              </SelectBorder>
            </div>


            {(updatedField.type === "dropdown" ||
              updatedField.type === "radio" ||
              updatedField.type === "checkbox") && (
                <div>
                  <InputLabel>Options</InputLabel>
                  {updatedField.options.map((option, index) => (
                    <div key={index} className="registration_edit_option">
                      <InputType
                        type="text"
                        value={option}
                        onChange={(e) => updateOption(index, e.target.value)}
                      />
                      <RiDeleteBin4Fill
                        className="registration_edit_remove"
                        onClick={() => removeOption(index)}
                      />
                    </div>
                  ))}
                  <div className="registration_edit_addoption" onClick={addValue}>
                    Add Option
                  </div>
                </div>
              )}

            {updatedField.type === "file" && (
              <div className="registration_edit_row">
                <InputLabel>Enter File Size (MB)</InputLabel>
                <InputType
                  type="text"
                  name="uploadFileSize"
                  value={
                    conditions.uploadFileSize ||
                    (fieldPayload &&
                      fieldPayload.find(item => item.dataName === field.dataName)
                        ?.uploadFileSize) || ''
                  }
                  onChange={handleChange}
                />


                <div className="registration_edit_row">
                  <InputLabel>Select File Types</InputLabel>
                  <SelectBorder
                    as="select"
                    name="uploadFileType"
                    value=""
                    onChange={handleMultiSelect}
                  >
                    <option value="" disabled>
                      Select file type
                    </option>
                    {fileTypes.map((type) => (
                      <option
                        key={type}
                        value={type}
                        style={{
                          backgroundColor: conditions.uploadFileType.includes(type)
                            ? "#d3d3d3" 
                            : "white",
                        }}
                      >
                        {type}
                      </option>
                    ))}
                  </SelectBorder>
                  <div style={{ marginTop: "10px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
      {conditions.uploadFileType.map((option) => (
        <div
          key={option}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "4px 8px",
            borderRadius: "16px",
            backgroundColor: "#e0e0e0",
            fontSize: "12px",
            color: "#333",
          }}
        >
          {option}
          <button
            onClick={() => removeOptionDrop(option)}
            style={{
              marginLeft: "6px",
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              color: "#888",
              fontSize: "14px",
              lineHeight: "1",
              display: "flex",
              alignItems: "center",
            }}
            title="Remove"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
                </div>
              </div>
            )}


            {
              isAddedField && (
                <>
                  {/* Required If Section */}
                  <div className="required-field">
                    <label>
                      <input
                        type="checkbox"
                        checked={
                          conditions.isRequiredChecked
                        }
                        onChange={() =>
                          setConditions((prev) => ({
                            ...prev,
                            isRequiredChecked: !prev.isRequiredChecked,
                          }))
                        }
                      />
                      Required
                    </label>
                    {conditions.isRequiredChecked && (
                      <div>
                        <label>
                          <input
                            type="checkbox"
                            checked={conditions.isRequiredIf}
                            onChange={handleConditionChange
                            }
                            name="isRequiredIf"
                          />
                          Required if
                        </label>
                        {conditions.isRequiredIf && (
                          <>
                            <div className="registration_edit_row">
                              <InputLabel>Required Field</InputLabel>
                              <SelectBorder
                                value={conditions.requiredFieldValue || ""}
                                onChange={handleConditionChange}
                                name="requiredFieldValue"
                              >
                                <option value="">Select Field</option>
                                {formSchema.map((item) => (
                                  <option key={item.dataName} value={item.label}>
                                           {item.label.length > 60 ? `${item.label.slice(0, 150)}...` : item.label}
                                           </option>
                                ))}
                              </SelectBorder>
                            </div>
                            <div className="registration_edit_row">
                              <InputLabel>Condition</InputLabel>
                              <SelectBorder
                                value={conditions.requiredCondition}
                                onChange={handleConditionChange}
                                name="requiredCondition"
                              >
                                <option value="Equals ">Equals (Default)</option>
                                <option value="contains">Contains</option>
                                <option value="not-contains">Not Contains</option>
                                <option value="startsWith">Starts With</option>
                                <option value="not-startsWith">Not Starts With</option>
                                <option value="endsWith">Ends With</option>
                                <option value="not-endsWith">Not Ends With</option>
                              </SelectBorder>
                            </div>
                            <div className="registration_edit_row">
                              <InputLabel>Condition Value</InputLabel>
                              <InputType
                                type="text"
                                value={conditions.requiredConditionValue || ""}
                                onChange={handleConditionChange}
                                name="requiredConditionValue"
                              />
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Visible If Section */}
                  <div className="visible-field">
                    <label>
                      <input
                        type="checkbox"
                        checked={
                          conditions.isVisibleChecked
                        }
                        onChange={() =>
                          setConditions((prev) => ({
                            ...prev,
                            isVisibleChecked: !prev.isVisibleChecked,
                          }))
                        }
                      />
                      Visible
                    </label>
                    {conditions.isVisibleChecked && (
                      <div>
                        <label>
                          <input
                            type="checkbox"
                            checked={conditions.isVisibleIfChecked}
                            onChange={
                              handleConditionChange
                            }
                            name="isVisibleIfChecked"
                          />
                          Visible if
                        </label>
                        {conditions.isVisibleIfChecked && (
                          <>
                            <div className="registration_edit_row">
                              <InputLabel>Visible Field</InputLabel>
                              <SelectBorder
                                value={conditions.visibleFieldValue}
                                onChange={handleConditionChange}
                                name="visibleFieldValue"
                              >
                                <option value="">Select Field</option>
                                {formSchema.map((item, index) => (
                                  <option key={index} value={item.dataName}>
                                           {item.label.length > 60 ? `${item.label.slice(0, 150)}...` : item.label}
                                           </option>
                                ))}
                              </SelectBorder>


                            </div>
                            <div className="registration_edit_row">
                              <InputLabel>Condition</InputLabel>
                              <SelectBorder
                                value={conditions.visibleCondition}
                                onChange={handleConditionChange}
                                name="visibleCondition"
                              >
                                <option value="Equals ">Equals (Default)</option>
                                <option value="contains">Contains</option>
                                <option value="not-contains">Not Contains</option>
                                <option value="startsWith">Starts With</option>
                                <option value="not-startsWith">Not Starts With</option>
                                <option value="endsWith">Ends With</option>
                                <option value="not-endsWith">Not Ends With</option>
                              </SelectBorder>
                            </div>
                            <div className="registration_edit_row">
                              <InputLabel>Condition Value</InputLabel>
                              <InputType
                                type="text"
                                value={conditions.visibleConditionValue || ""}
                                onChange={handleConditionChange}
                                name="visibleConditionValue"
                              />
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </>
              )
            }

          </form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <GreyBorderButton onClick={onClose}>Cancel</GreyBorderButton>
        <RedBackgroundButton onClick={handleSave}>Save</RedBackgroundButton>
      </Modal.Footer>
    </Modal>
  );
};

export default EditFieldModal;
